export const heroData = {
  title: 'Projetos que traduzem essência, conforto e atemporalidade.',
  subtitle: 'Arquitetura e interiores',
  cta: 'Vamos conversar sobre o seu projeto!',
  bgImage:
    'https://static.readdy.ai/image/ac022146e5e324748b77e0d4e56bfc05/66b319635b268e5fb78e4dfe0ad8e7ee.png',
};

export const projetosData = {
  label: 'Portfólio',
  title: 'Projetos recentes',
  description:
    'Cada projeto reflete nosso compromisso com excelência, inovação e atendimento personalizado.',
  projects: [
    {
      id: '1',
      name: 'Suíte Aconchego',
      image:
        'https://static.readdy.ai/image/ac022146e5e324748b77e0d4e56bfc05/60a58e4a6bc3a40011868f8b3d516cde.jpeg',
      span: 'md:row-span-2',
      aspect: '3/4',
    },
    {
      id: '2',
      name: 'Residência Solare',
      image:
        'https://static.readdy.ai/image/ac022146e5e324748b77e0d4e56bfc05/49f5ce4b00788b7269a7fc7f756a3af8.png',
      span: '',
      aspect: '4/3',
    },
    {
      id: '3',
      name: 'Home Office Essência',
      image:
        'https://static.readdy.ai/image/ac022146e5e324748b77e0d4e56bfc05/e3d7b60adf5e772a3349343afefff8ba.jpeg',
      span: 'md:row-span-2',
      aspect: '3/4',
    },
    {
      id: '4',
      name: 'Lavabo Duna',
      image:
        'https://static.readdy.ai/image/ac022146e5e324748b77e0d4e56bfc05/1548d7b5579be073f8568352866a8dec.png',
      span: '',
      aspect: '4/3',
    },
    {
      id: '5',
      name: 'Residencial B&G',
      image:
        'https://static.readdy.ai/image/ac022146e5e324748b77e0d4e56bfc05/06c02e0d29228897efca26bb68deb17b.jpeg',
      span: 'md:col-span-2',
      aspect: '16/9',
    },
    {
      id: '6',
      name: 'Refúgio Contemporâneo',
      image:
        'https://static.readdy.ai/image/ac022146e5e324748b77e0d4e56bfc05/4c58cb81de7abf551a26d8b4c272463f.jpeg',
      span: '',
      aspect: '3/4',
    },
  ],
};

export const arquitetaData = {
  title: 'Stephanie Zarowny',
  cta: 'Vamos conversar sobre o seu projeto?',
  paragraphs: [
    'Muito prazer, eu sou a Stephanie Zarowny, arquiteta formada pelo Centro Universitário Curitiba em 2020. Acredito que a verdadeira arquitetura vai muito além de erguer paredes; trata-se de criar o cenário onde a sua vida vai acontecer da melhor forma possível, unindo funcionalidade a um olhar sensível para o seu bem-estar.',
    'Vejo cada projeto não apenas como uma construção, mas como uma narrativa visual muito pessoal, desenvolvida a quatro mãos com você. Faço questão de ouvir a sua história e entender a sua rotina para que as escolhas construtivas dialoguem intimamente com o seu cotidiano.',
    'Para mim, um projeto de sucesso é aquele que se torna o reflexo fiel de quem o habita. Minha abordagem busca equilibrar a técnica arquitetônica com os seus desejos mais particulares, garantindo que cada ambiente não seja apenas visualmente equilibrado, mas acima de tudo, funcional e confortável para o seu dia a dia. Acredito em uma arquitetura atemporal, que valoriza a iluminação, a ventilação e a escolha inteligente de acabamentos que façam sentido para você. Meu grande objetivo é entregar um refúgio autêntico, onde você se sinta verdadeiramente em casa e onde cada detalhe tenha sido pensado para acolher a sua história.',
  ],
};

export const servicosData = {
  title: 'Nossos serviços',
  items: [
    {
      name: 'Projetos Residenciais',
      icon: 'ri-home-3-line',
      desc: 'Projetos que respeitam a sua história e estilo de vida, unindo técnica e sensibilidade para criar o seu refúgio autêntico.',
    },
    {
      name: 'Projetos Comerciais',
      icon: 'ri-building-2-line',
      desc: 'Entendemos a importância estratégica de ambientes eficientes e atrativos. Desenvolvemos espaços que não apenas operam bem, mas também conectam a marca ao seu público, garantindo o sucesso do seu negócio.',
    },
    {
      name: 'Aprovações e Projetos Legais',
      icon: 'ri-shield-check-line',
      desc: 'Cuidamos de toda a viabilidade técnica e burocrática junto aos órgãos municipais. Elaboramos projetos legais de aprovação, garantindo total segurança jurídica e conformidade com as normas locais.',
    },
    {
      name: 'Orçamentos e Planejamento',
      icon: 'ri-survey-line',
      desc: 'Realizamos uma análise completa dos custos e do cronograma da obra. Nossa transparência orçamentária e planejamento detalhado evitam surpresas e garantem a execução tranquila do seu projeto.',
    },
    {
      name: 'Acompanhamento de Obra',
      icon: 'ri-hammer-line',
      desc: 'Acompanho de perto cada etapa da execução, oferecendo suporte técnico constante para garantir que o projeto seja realizado conforme o planejado e com os mais altos padrões de qualidade e prazo.',
    },
    {
      name: 'Projetos de Reformas',
      icon: 'ri-tools-line',
      desc: 'Transformar espaços existentes exige um olhar técnico e criativo. Renovamos e otimizamos ambientes, trazendo um novo significado e funcionalidade à sua residência ou negócio.',
    },
  ],
};

export const diferenciaisData = {
  title: 'Seu projeto com nosso escritório',
  items: [
    {
      number: '01',
      title: 'Atendimento personalizado',
      desc: 'Cada cliente é único. Desenvolvemos soluções exclusivas que traduzem a personalidade e o estilo de vida de quem vai habitar o espaço.',
    },
    {
      number: '02',
      title: 'Acompanhamento completo',
      desc: 'Do primeiro esboço até a entrega das chaves, acompanhamos cada etapa do projeto com rigor técnico e atenção aos detalhes.',
    },
    {
      number: '03',
      title: 'Materiais de alta qualidade',
      desc: 'Trabalhamos exclusivamente com fornecedores selecionados e materiais que garantem durabilidade, estética e valorização do imóvel.',
    },
    {
      number: '04',
      title: 'Prazos comprometidos',
      desc: 'Respeitamos os prazos estabelecidos, com planejamento minucioso e gestão eficiente de cada fase do projeto.',
    },
  ],
};

export const processoData = {
  title: 'Como trabalhamos',
  steps: [
    {
      number: '01',
      title: 'Reunião inicial',
      desc: 'Entendemos seus desejos, necessidades e o potencial do espaço. Essa etapa é fundamental para alinhar expectativas e criar a base do projeto.',
    },
    {
      number: '02',
      title: 'Projeto criativo',
      desc: 'Desenvolvemos o conceito visual, plantas, moodboards e renders que materializam a identidade do seu futuro espaço.',
    },
    {
      number: '03',
      title: 'Projeto executivo',
      desc: 'Detalhamos todas as especificações técnicas, acabamentos e fornecedores para garantir a execução perfeita da obra.',
    },
  ],
};

export const depoimentosData = {
  title: 'O que nossos clientes dizem',
  items: [
    {
      text: 'Nossa casa ficou maravilhosa! O resultado superou todas as nossas expectativas e não poderíamos estar mais felizes com a nossa escolha.',
      author: '',
    },
    {
      text: 'Profissionalismo, criatividade e sensibilidade impecáveis. Nosso apartamento ganhou uma nova vida com o projeto da Stephanie. Recomendo de olhos fechados.',
      author: '',
    },
    {
      text: 'Do primeiro contato até a entrega final, fomos tratados com extrema atenção. O projeto da nossa loja ficou exatamente como imaginávamos: elegante, funcional e atemporal.',
      author: '',
    },
  ],
};

export const contatoData = {
  title: 'Vamos projetar o seu próximo capítulo?',
  description: 'Do seu lar ao seu negócio, vamos transformar sua visão em uma arquitetura autêntica e funcional.',
  cta: 'Entre em contato',
  info: [],
};